import React from "react";
import { Link } from "react-router-dom";
import { Toolbar, AppBar, Box } from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SettingsIcon from "@material-ui/icons/Settings";
import PersonIcon from "@material-ui/icons/Person";
import useStyles from "./styles";
import { ReactComponent as Logo } from "../../assets/spot-logo.svg";
import SearchBar from "../search-bar";
import NavItems from "./components/nav-items";
import IconItems from "./components/icon-items";

const icons = [
  { icon: <ExitToAppIcon />, link: "/" },
  { icon: <SettingsIcon />, link: "/settings" },
  { icon: <PersonIcon />, link: "/profile" },
];

const CustomAppBar = ({ children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <AppBar position="fixed" className={classes.appbar}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.textGroup}>
            <Link to="/">
              <Logo />
            </Link>
            <NavItems />
          </div>
          <SearchBar />
          <IconItems
            groupStyle={classes.iconGroup}
            iconStyle={classes.iconButton}
            icons={icons}
          />
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        <div className={classes.mainContent} />
        {children}
      </main>
    </Box>
  );
};

export default CustomAppBar;
